import { Float, TorusKnot } from "@react-three/drei";
import { Aluminium, Chrome, Copper, GlossyCeramic, GlossyPlastic, Gold, MatteCeramic, MattePlastic, PaintedGreenMaterial, PCBGreen, Rubber, Tin, TranslucentWhitePlastic } from "./FluxMaterials";

export default function FluxTeapots()
{
    return <>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[0,0,0]}>
            <Copper />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[0,0,-1]}>
            <GlossyCeramic />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[0,0,1]}>
            <MatteCeramic />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[0,1,0]}>
            <MattePlastic />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[0,-1,0]}>
            <GlossyPlastic />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[-1,0,0]}>
            <Aluminium />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[1,0,0]}>
            <Chrome />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[-1,0,1]}>
            <Gold />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 200, 200, 2, 3 ]} position={[-1,0,-1]}>
            <Rubber />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 200, 25, 2, 3 ]} position={[-1,1,1]}>
            <TranslucentWhitePlastic />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[1,0,1]}>
            <Tin />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[1,0,-1]}>
            <PaintedGreenMaterial />
        </TorusKnot>

        <TorusKnot args={ [ .2, .05, 100, 16, 2, 3 ]} position={[1,-1,0]}>
            <PCBGreen />
        </TorusKnot>
    </>
}